module.exports = __webpack_public_path__ + "static/media/aviationaviationinfrastructure.87b41b8f.png";